import { LearningBudgetService } from '@/services/learning-budget';
import { ApiReactQueryOptions } from '@/types/api';
import {
  ApiLearningBudgetTransactionsDigestResponse,
  ILearningBudgetTransactionFilters,
} from '@/types/learning-budget';
import { useQuery } from '@tanstack/react-query';

export function useLearningBudgetTransactionsDigest(
  filters?: ILearningBudgetTransactionFilters,
  options?: ApiReactQueryOptions<ApiLearningBudgetTransactionsDigestResponse>,
) {
  return useQuery({
    queryKey: [
      LearningBudgetService.TRANSACTIONS_PATH,
      { ...filters, digest: true },
    ],
    queryFn: () =>
      LearningBudgetService.getLearningBudgetTransactionsDigest({
        ...filters,
        digest: true,
      }),
    ...options,
  });
}
